module.exports = __webpack_public_path__ + "img/20190523210829微信截图_20190523211224.a8513009.png";